import React from "react";
import { Outlet } from "react-router-dom";

function Analytics() {
  return <Outlet />;
}
export default Analytics;
